module.exports = "<template>\n    <sio-time-input\n        config.bind=\"field\"\n        value.bind=\"field.value\"\n    ></sio-time-input>\n</template>\n";